<template>
  <li>
    <div class="row">
      <div class="col-12 col-xl-3">
        <div class="row gx-0 overflow-hidden">
          <div class="col-auto d-flex align-items-center">
            <i
              class="fab fa-2x text-primary ms-1 me-2"
              :class="{
                'fa-php': dependency.platform === 'packagist',
                'fa-npm': dependency.platform === 'npm',
              }"
            ></i>
          </div>
          <div
            class="col d-flex align-items-center chip"
            v-tooltip.top="
              `${dependency.name}@${dependency.version_constraint}`
            "
          >
            <p>
              <a v-if="dependency.repository_url" :href="dependency.repository_url" target="_blank">
                {{ dependency.name }}@{{ dependency.version_constraint }} <i class="far fa-external-link-alt fa-fw fa-sm"></i>
              </a>
              <template v-else>
                {{ dependency.name }}@{{ dependency.version_constraint }}
              </template>
            </p>
          </div>
        </div>
      </div>
      <div class="col-4 col-xl-2">
        <p>
          <span class="data-label d-xl-none">Installed</span>
          {{ dependency.version_installed }}
        </p>
      </div>
      <div class="col-4 col-xl-2">
        <p>
          <span class="data-label d-xl-none">Available</span>
          {{ dependency.version_available || "-" }}
        </p>
      </div>
      <div class="col-4 col-xl-2">
        <p>
          <span class="data-label d-xl-none">Latest</span>
          {{ dependency.version_latest }}
        </p>
      </div>
      <div class="col-12 col-xl-3 d-flex justify-content-xl-between justify-content-sm-start justify-content-between flex-wrap">
        <router-link :to="{ name: 'support.project-dependencies.single.vulnerabilities', query: { severity: ['critical'], search: dependency.name, branch } }">
          <count-chip
            type="dark"
            :count="dependency.critical_vulnerabilities_count"
            suffix="C"
            force-show
          />
        </router-link>
        <router-link :to="{ name: 'support.project-dependencies.single.vulnerabilities', query: { severity: ['high'], search: dependency.name, branch } }">
          <count-chip
            type="danger"
            :count="dependency.high_vulnerabilities_count"
            suffix="H"
            force-show
          />
        </router-link>
        <router-link :to="{ name: 'support.project-dependencies.single.vulnerabilities', query: { severity: ['moderate'], search: dependency.name, branch } }">
          <count-chip
            type="warning"
            :count="dependency.moderate_vulnerabilities_count"
            suffix="M"
            force-show
          />
        </router-link>
        <router-link :to="{ name: 'support.project-dependencies.single.vulnerabilities', query: { severity: ['low'], search: dependency.name, branch } }">
          <count-chip
            type="light"
            :count="dependency.low_vulnerabilities_count"
            suffix="L"
            force-show
          />
        </router-link>
      </div>
    </div>
  </li>
</template>

<script>
import CountChip from './CountChip'

export default {
  props: {
    dependency: Object,
    branch: String
  },

  components: {
    CountChip
  }
}
</script>
